import { combineReducers } from "redux"

import all from "./all/slice"

const countryReducer = combineReducers({
  all,
})

export default countryReducer
